import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Card, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { selectSavedSearchById } from '../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import { connectModalContainerContextToComponent } from '../../contexts/ModalContext/ModalContext';
import AdvancedSearchUtility from '../../utility/AdvancedSearchUtility';
import FilterDisplay from './FilterDisplay';
import SearchType from '../../utility/types/SearchType';
import { RaaRoles } from '../../utility/SecurityRules';
import HasRolePrivileges from '../highorder/HasRolePrivileges';

function SavedSearchDetailsModal(props) {
  const {
    setModalJSX,
    searchId,
    handleEditClick,
    handleViewInListClick,
    searchType,
  } = props;
  const savedSearch = useSelector((state) => selectSavedSearchById(state, searchId));
  const [show, setShow] = useState(true);
  const entityName = searchType === SearchType.ALERT ? 'Alerts' : 'Devices';
  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const sortedFilters = AdvancedSearchUtility
    .sortFiltersByFacetType(savedSearch.filters);
  return (
    <Modal
      show={show}
      onHide={closeModalHandler}
      fullscreen="md-down"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>{savedSearch.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col">
            <h5>Description</h5>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Card>
              <Card.Body>
                <Card.Text>
                  {savedSearch.description}
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <h5>Filters</h5>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Card>
              <Card.Body>
                <div style={{
                  overflowY: 'auto',
                  maxHeight: '250px',
                }}
                >
                  <Card.Text>
                    <ol>
                      {Object.entries(sortedFilters)
                        .map(([k, v]) => (
                          <li className="mb-2">
                            <FilterDisplay facetId={parseInt(k, 10)} filters={v} />
                          </li>
                        ))}
                    </ol>
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col m-1">
            <i>
              To make changes to filters, load this Search in your
              {' '}
              {entityName}
              {' '}
              List. From there, click
              on any filter in the Search bar to make changes.
            </i>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
          <Button
            variant="secondary"
            onClick={handleEditClick}
          >
            Edit
          </Button>
        </HasRolePrivileges>
        <Button
          variant="secondary"
          onClick={handleViewInListClick}
          className="text-nowrap"
        >
          View in
          {' '}
          {entityName}
          {' '}
          List
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

SavedSearchDetailsModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  searchId: PropTypes.number.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleViewInListClick: PropTypes.func.isRequired,
  searchType: PropTypes.oneOf([0, 1, 2]).isRequired,
};

export default connectModalContainerContextToComponent(SavedSearchDetailsModal);
